import type { MultiSelectDimensionProps } from "../../components/dimensions/MultiSelectDimension";
import { DimensionTypes } from "../../types/dimensions";

import type { DimensionFixtureExample } from ".";

export const BaseMultiSelectDimensionProps: MultiSelectDimensionProps = {
    id: "multiselect",
    type: DimensionTypes.MULTISELECT,
    dependencies: [],
    configuration: {
        columns: [
            {
                column: "advertiser",
            },
            {
                column: "advertiser_id",
            },
            {
                column: "locale",
            },
        ],
        maxItemsSelected: 1000,
        queryDistinct: false,
        dropdownItemMapper: {
            value: "advertiser_id",
            labelFormat: "{locale}",
            detailsFormat: "{advertiser}||locale::{locale}",
            subTextFormat: "testing",
        },
        attachDatabaseResponseToMetadata: true,
        label: "advertisers",
        useTypeaheadSearchWithColumn: "advertiser",
        inputSource: "ahr_parameters",
    },
};

export const MultiSelectDimensionExamples: Record<
    string,
    DimensionFixtureExample
> = {
    base: {
        id: "multiselect_base",
        name: "multiselect dimension base",
        description: "only works with mock server",
        dimensions: [[BaseMultiSelectDimensionProps]],
    },
    dependency: {
        id: "multiselect_dependency",
        name: "multiselect dimension dependency",
        description: "only works with mock server",
        dimensions: [
            [
                {
                    id: "marketplace_id",
                    type: "input",
                    dependencies: [],
                    configuration: {
                        label: "marketplace id",
                    },
                    optional: true,
                } as any,
                {
                    ...BaseMultiSelectDimensionProps,
                    dependencies: ["marketplace_id"],
                    optional: true,
                },
            ],
        ],
    },
};
